import { useAppDispatch, useAppSelector } from '@/renderer/hooks/useRedux';
import { selectGroupedOrderItems } from '@/renderer/store/runningOrder/runningOrderSelectors';
import { openOrderItemsModalForGroup } from '@/renderer/store/runningOrder/runningOrderSlice';
import React from 'react';

export const OrderItemsWrapper: React.FC = () => {
  const dispatch = useAppDispatch();
  const groupedItems = useAppSelector(selectGroupedOrderItems);

  return (
    <table className="w-full border-collapse">
      <tbody>
        {groupedItems.map((item) => (
          <tr
            key={item.key}
            className={`cursor-pointer border-b border-gray-200 last:border-0 transition-colors ${
              item.hasPending ? 'app-bg hover:bg-[#cfd8dd]' : 'hover:bg-gray-50'
            }`}
            onClick={() => {
              dispatch(openOrderItemsModalForGroup(item.key));
            }}
          >
            <td className="align-top px-4 py-3 text-sm text-black">
              <div className="flex flex-col gap-1">
                <span className="app-item-name block">
                  {item.quantity.toLocaleString()} {item.name}
                </span>
                <span className="text-xs text-black/70">
                  {item.lineCount.toLocaleString()} KOT
                  {item.lineCount === 1 ? '' : 's'}
                  {item.pendingCount > 0
                    ? ` • ${item.pendingCount.toLocaleString()} pending`
                    : ''}
                </span>
              </div>
            </td>

            <td className="w-28 align-top px-4 py-3 text-right text-sm font-semibold text-black">
              {item.amount.toLocaleString()}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
